import styled from 'styled-components'

export default styled.div`
  .cart-item-row {
    border-bottom: 1px solid #c7c7cc;
    padding: 12px 16px 14px 0;
    margin: 0 0 0 16px;
    /* width: 100vw; */

    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;

    position: relative;
  }

  .remove-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 8px;

    &:before {
      content: '';
      display: block;
      width: 16px;
      height: 16px;

      background: url('data:image/svg+xml;utf8,<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M18 1.188l-1.2-1.2L9 7.795 1.2-.012 0 1.188l7.8 7.807L0 16.8 1.2 18 9 10.193 16.8 18l1.2-1.2L10.2 9z" fill="%23808080" fill-rule="nonzero"/></svg>') no-repeat scroll center center;
      background-size: contain;

    }
  }

  .product-image-container {
    width: 16vw;
    max-width: 100px;
    margin-right: 5vw;
  }
  .product-details {
    width: 62vw;
  }

  .product-image, .product-image-default {
    /* height: 60px; */
    width: auto;
    max-width: 100%;
  }


  .product-name {
    margin-bottom: 5px;
  }

  /* .color-size-slash, .size_option_label {
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    color: rgb( 103, 103, 103);
    font-size: 11px;
  } */

  .color-option-label {
    display: block;
    line-height: 1em;
    .color-swatch {
      position: absolute;
      left: 1px;
      top: 0px;
    }

    .size-label, .shadetext {
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 11px;
      letter-spacing: -0.4px;
      text-align: left;
      vertical-align: bottom;
    }
  }

  .quantity-row {
    margin-bottom: -2px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .quantity-selector-container {
    position: relative;
    margin-right: 16px;

    .quantity {
      font-family: 'ABChanel PB Regular M', Arial, sans-serif;
      font-size: 12px;
      padding-left: 24px;
      padding-right: 24px;
    }

    button:disabled {
      opacity: 0.3;
    }
  }

  .item-price {
    font-family: 'ABChanel PB Regular M', Arial, sans-serif;
    font-size: 11px;
  }

  .subtotal-price {
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 13px;
    margin: 0.75em 0 0;
  }

  .item-error-box {
    margin-top: 11px;
    margin-bottom: 5px;
  }
`



// WEBPACK FOOTER //
// ./src/styles/CartItem.js